import script from "./add-aggregates.vue?vue&type=script&setup=true&lang=js"
export * from "./add-aggregates.vue?vue&type=script&setup=true&lang=js"

import "./add-aggregates.vue?vue&type=style&index=0&id=447f61c6&lang=scss&scoped=true"

import exportComponent from "E:\\茂侨项目文件夹\\monitoring-platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-447f61c6"]])

export default __exports__